import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardCodeListTemplate } from 'components/Templates'

const PointCardCodeList: FC = () => {
  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'QRコード'} title={'QRコード'}>
      <PointCardCodeListTemplate />
    </Layout>
  )
}

export default PointCardCodeList
